<template>
	<div class="cam-calculator">
		<h2 v-if="hasSeededTeamSize" class="title is-4 mb-4">While you wait, see what Cam could do for your team</h2>
		<TeamSizePicker v-else />

		<CapacityBoard :capacity="capacity" />

		<section class="cam-box" aria-label="Book a demo">
			<div class="columns is-vcentered is-variable is-2-mobile is-4-tablet">
				<div class="column">
					<h2 class="title is-5 mb-0">
						See Cam working on your own org in 30 minutes
					</h2>
				</div>

				<div class="column is-narrow-tablet">
					<a
						v-if="context === 'embed'"
						class="button is-orange"
						:href="ctaHref"
						target="_blank"
						rel="noopener"
					>
						Book a demo
					</a>
					<button
						v-else
						ref="calendlyButton"
						class="button is-orange"
						type="button"
						data-calendly="agent-walkthrough"
						data-calendly-account="gearset-customer"
					>
						Book a demo
					</button>
				</div>
			</div>
		</section>
	</div>
</template>

<script>

import calendly from 'Scripts/calendly.js';

import CapacityBoard from './CapacityBoard.vue';
import TeamSizePicker from './TeamSizePicker.vue';

import { computeCapacity } from '../calculations.js';

export default {
	components: {
		CapacityBoard,
		TeamSizePicker,
	},

	props: {
		context: {
			type: String,
			default: 'page',
		},

		ctaHref: {
			type: String,
			default: '/agent-walkthrough/',
		},

		hasSeededTeamSize: {
			type: Boolean,
			default: false,
		},
	},

	computed: {
		capacity() {
			return computeCapacity({
				volume: this.$store.volume,
				hours: this.$store.hours,
				share: this.$store.share,
			});
		},
	},

	mounted() {
		if (this.$refs.calendlyButton) {
			calendly.setUpCalendlyTrigger(this.$refs.calendlyButton);
		}
	},
};

</script>

<style lang="scss" scoped>
@import '@gearset/web-core/styles/includes/variables';

.cam-box {
	background: $white-ter;
	border: 0;
	border-radius: 1.5rem;
	padding: 1.5rem;

	&:not(:last-child) {
		margin-bottom: .75rem;
	}
}

</style>
